import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskPassword'
})
export class MaskPasswordPipe implements PipeTransform {

  transform(clearPassword: string | null | undefined): string {
    if (!clearPassword) {
      return '';
    }
    return '*'.repeat(clearPassword.length);
  }

}
